const [ w, d, l, content ] = [ window, document, location, 'aboutus' ]

const init = ID => {
  $.when(
    w.load['nav-aboutus-head'],
    w.load['nav-aboutus-foot']
  ).then( () => {
    $('[data-plugin="currentMenu"]').currentMenu()
  })
}

export default function ABOUTUS () {
  $(() => init( w.query_string('article') ) )
}